<template>
  <section>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <PageHeader
            :title="headercontent.title"
            :addlink="headercontent.addlink"
          />
        </v-col>
        <v-col md="12">
          <v-simple-table class="table" v-if="!allLoadingCurd" >
            <template v-slot:default v-if="allEmotions.results">
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-right" colspan="2">Edit</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in allEmotions.results" :key="index">
                  <td  class="text-capitalize">{{ item.name }}</td>
                  
                  <td class="text-right">
                    <v-icon class="icons-action" v-if="index > 0" @click="moveEmotionUp(index)">mdi-chevron-up</v-icon>
                    <v-icon class="icons-action" v-if="index < allEmotions.results.length - 1" @click="moveEmotionDown(index)">mdi-chevron-down</v-icon>
                    <router-link :to="`/dashboard/emotion/${item.id}`">
                      <v-icon class="icons-action" v-if="true">mdi-pencil</v-icon>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
           <div  v-if="allLoadingCurd">
            <v-skeleton-loader type="image" height="200"></v-skeleton-loader>
            <v-skeleton-loader type="image" height="200"></v-skeleton-loader>
          </div>
          
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import PageHeader from "@/components/dashboard/PageHeader";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Emotion",
  components: { PageHeader },
  data: () => ({
    headercontent: {
      title: "Emotions",
      addlink: "/dashboard/emotion/add",
    },
  }),
  methods: {
    validate() {},
    ...mapActions(["fetchEmotions", "swapEmotions"]),
    moveEmotionUp(index) {
      this.swapEmotions({ emotions: this.allEmotions, indices: [index - 1, index] });
    },
    moveEmotionDown(index) {
      this.swapEmotions({ emotions: this.allEmotions, indices: [index, index + 1] });
    },
  },
  created() {
    this.fetchEmotions();
  },
  computed: {
    ...mapGetters(["allEmotions","allLoadingCurd"]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.form-section {
  padding: 15px 0;
  .col {
    padding: 0 10px;
  }
}
.filtertitle {
  margin-bottom: 10px;
}
.btn-dark {
  background: $tagcolor !important;
  color: $white;
  margin-top: -10px;
}

.table {
  box-shadow: 0px -1px 5px 2px rgba(0, 0, 0, 0.1);

  thead {
    border-bottom: 2px solid $menucolor;
    background: $tagcolor;
  }
  th {
    font-size: $normal_lfont !important;
    color: $white !important;
  }
  td {
    img {
      width: 100px;
      padding: 20px;
    }
  }
}
.pagination-button {
  display: flex;
  list-style: none;
  padding-left: 0;
  justify-content: space-between;
  box-shadow: 2px 2px 5px 2px rgba(0, 0, 0, 0.1);
  .btn-dark {
    margin-top: 0;
    margin-left: 10px;
  }
}
.table-heading,
.pagination-button {
  border: 1px solid $menucolor;
  margin-bottom: 0;
  padding: 10px;
  align-items: center;
}
.icons-action {
  margin: 10px;
  font-size: $iconfont;
}
</style>
